<template>
	<component
		:is="type"
		class="leading-tight"
		:class="{
			'text-4xl md:text-7xl font-semibold': type == 'h1',
			'text-3xl md:text-5xl font-semibold': type == 'h2',
			'text-xl md:text-4xl font-semibold': type == 'h3',
			'text-xl md:text-3xl font-medium': type == 'h4',
			'text-xl md:text-2xl font-medium': type == 'h5',
			'text-xl font-medium': type == 'h6',
		}"
	>
		<slot></slot>
	</component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "BaseHeading",
	props: {
		type: {
			type: String,
			default: "h1",
		},
	},
});
</script>
